import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ClientItem } from 'owa-mail-store';

export default function getConversationId(viewState: ItemViewState, item: ClientItem): string {
    return viewState.isConversationItemPart ? item.ConversationId?.Id : null;
}
